export default __webpack_public_path__ + "static/media/exterior-6.c805bbe9.webp";